export default __webpack_public_path__ + "static/media/CurrentImg.1476e01c.jpg";